import template from './ap-pdfs-get.html.twig';

const {Criteria} = Shopware.Data;
Shopware.Component.register('ap-pdfs-check', {
    template,
    inject: ['repositoryFactory'],
    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },
    data() {
        return {
            invoiceNumber: '',
            addressNumber: '',
            invoiceEmailAddress: '',
            invoiceEmailSubject: '',
            invoiceEmailText: '',
            isLoading: false,
            errorMessage: [],
            isError: false,
            processSuccess: false,
            showResultsContainer: false
        };
    },
    methods: {
        apOnClickPDFFetch() {
            this.isLoading = true;
            this.isError = false;
            this.showResultsContainer = false;
            this.apRequestCall('/ap/fetch-pdf', 'download');
        },
        apOnClickPDFSend() {
            this.isLoading = true;
            this.isError = false;
            this.showResultsContainer = false;
            this.apRequestCall('/ap/send-pdf', 'email');
        },
        apRequestCall(urlAction, responseAction) {
            const httpClient = Shopware.Application.getContainer('init').httpClient;
            const config = {
                url: urlAction,
                method: 'get',
                baseURL: '',
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                params: {
                    IN: this.invoiceNumber,
                    CN: this.addressNumber,
                    EM: this.invoiceEmailAddress,
                    ES: this.invoiceEmailSubject,
                    EC: this.invoiceEmailText
                },
                timeout: 30000,
                validateStatus: function (status) {
                    return status >= 200 && status < 300; // default
                }
            };
            httpClient.request(config).then((response) => {
                return this.apHandlePDFResponse(response, responseAction);
            });
        },
        apHandlePDFResponse(response, action) {
            this.isLoading = false;
            this.showResultsContainer = true;
            this.errorMessage = [];
            let apPDFDataResult = response.data;
            if (apPDFDataResult === null || apPDFDataResult === undefined) {
                this.isError = true;
                this.errorMessage.push('ap-pdfs.error.invalidResponse');
                return;
            }
            if (apPDFDataResult.error) {
                this.isError = true;
                for (let key in apPDFDataResult.messages) {
                    this.errorMessage.push(apPDFDataResult.messages[key]);
                }
                return;
            }
            if (action === 'download') {
                this.isError = false;
                this.showResultsContainer = false;
                let byteCharacters = atob(apPDFDataResult.pdfData);
                let byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                let byteArray = new Uint8Array(byteNumbers);
                let blob = new Blob([byteArray], {type: 'application/pdf'});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = apPDFDataResult.pdfName;
                link.click();
            }else if(action === 'email'){
                this.isError = true;
                this.showResultsContainer = true;
                this.errorMessage.push('ap-pdfs.content.emailSent');
            }
            this.apClearForm();

        },
        apSaveFinish() {
            this.processSuccess = true;
        },
        apClearForm() {
            this.invoiceNumber = '';
            this.addressNumber = '';
            this.invoiceEmailAddress = '';
            this.invoiceEmailSubject = '';
            this.invoiceEmailText = '';
        }
    }
});
